import { Box, Typography, useTheme } from '@mui/material';
import ExpandableBox from 'src/components/common/ExpandableBox';
import TableHorizontal from 'src/components/TableHorizontal';

const ProductBrand = ({ tradeDataDetail }: { tradeDataDetail: IBillOfLadingDetail }) => {
  const {
    palette: { background },
    shape,
  } = useTheme();
  return (
    <ExpandableBox title="Product Brand" openDefault={true} flex={1}>
      <Box
        padding={3}
        display="flex"
        flexDirection="column"
        bgcolor={background.default}
        borderRadius={`0px 0px ${shape.borderRadius * 2}px ${shape.borderRadius * 2}px`}
      >
        <TableHorizontal
          colKeyWidth={350}
          configColumn={[
            {
              label: 'Brand Name',
              renderCell(data) {
                return (
                  <Typography variant="body2" color={'text.secondary'}>
                    {tradeDataDetail.transaction?.product_brand_name}
                  </Typography>
                );
              },
            },
            {
              label: 'Description',
              renderCell(data) {
                return (
                  <Typography variant="body2" color={'text.secondary'}>
                    {tradeDataDetail.transaction?.description}
                  </Typography>
                );
              },
            },
          ]}
          data={tradeDataDetail}
        />
      </Box>
    </ExpandableBox>
  );
};

export default ProductBrand;
